export const ROLLOUT_EXPERIMENT_ACTION = "extension/RolloutExperiment";
export const WAIT_EXPERIMENT_ACTION = "wait/experimentWaitTime";
export const HEALTH_CHECK_ACTION = "mdmHealthCheck/MonitorExperiment";

export const READABLE_ACTION_MAP: { [key: string]: string } = {
  [ROLLOUT_EXPERIMENT_ACTION]: "Rollout Experiment",
  [WAIT_EXPERIMENT_ACTION]: "Experiment Wait",
  [HEALTH_CHECK_ACTION]: "Health Check",
};

export const MPAC_TYPE = "MPAC";
export const RC_TYPE = "RC";
export const PROD_TYPE = "PROD";
export const ROLLBACK_TYPE = "Full Rollback";
export const MPAC_ABN_TYPE = "MPAC_ABN";
export const RC_ABN_TYPE = "RC_ABN";
export const PROD_ABN_TYPE = "PROD_ABN";

type StageType = {
  action: string;
  treatment: string;
  region: string;
};
export const RC_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "RC",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "RC",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "RC",
  },
];

export const MPAC_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "50",
    region: "MPAC",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "50",
    region: "MPAC",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "50",
    region: "MPAC",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "MPAC",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "MPAC",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "MPAC",
  },
];

export const PROD_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "1",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "1",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "1",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "10",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "10",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "10",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "40",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "40",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "40",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "50",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "50",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "50",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "Prod",
  },
];

export const ROLLBACK: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "Full Rollback",
    region: "All",
  },
];

export const RC_ABN_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "RC",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "RC",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "RC",
  },
];

export const MPAC_ABN_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "MPAC",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "MPAC",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "MPAC",
  },
];

export const PROD_ABN_STAGES: StageType[] = [
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "2",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "2",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "2",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "20",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "20",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "20",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "80",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "80",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "80",
    region: "Prod",
  },
  {
    action: ROLLOUT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "Prod",
  },
  {
    action: WAIT_EXPERIMENT_ACTION,
    treatment: "100",
    region: "Prod",
  },
  {
    action: HEALTH_CHECK_ACTION,
    treatment: "100",
    region: "Prod",
  },
];

export const TREATMENT_STAGE_MAP: Record<string, StageType[]> = {
  [MPAC_TYPE]: MPAC_STAGES,
  [RC_TYPE]: RC_STAGES,
  [PROD_TYPE]: PROD_STAGES,
  [ROLLBACK_TYPE]: ROLLBACK,
  [MPAC_ABN_TYPE]: MPAC_ABN_STAGES,
  [RC_ABN_TYPE]: RC_ABN_STAGES,
  [PROD_ABN_TYPE]: PROD_ABN_STAGES,
};
